import React from 'react';

import { ApiBalanceHistoryEvent } from '#/api/types';
import BasicTableStackable from '#/components/basic/table/BasicTableStackable';
import TextNumber from '#/components/basic/text/TextNumber';
import { formatDateTime } from '#/lib/date';
import { formatUsd } from '#/lib/display/formatting';
import { useSelector } from '#/reduxState/store';

import BalanceTransactionChain from './BalanceTransactionChain';
import BalanceTransactionFee from './BalanceTransactionFee';
import BalanceTransactionStatuses from './BalanceTransactionStatuses';
import BalanceTransactionType from './BalanceTransactionType';

type Params = {
  initialized: boolean;
  loading: boolean;
  historyEvents: ApiBalanceHistoryEvent[];
  onSelectRow: (transaction: ApiBalanceHistoryEvent) => void;
};

export default function BalancesHistoryTable({
  initialized,
  loading,
  historyEvents,
  onSelectRow,
}: Params) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const isMobile = useSelector(state => state.screen.isMobile);
  return (
    <BasicTableStackable
      stripes
      notFixedLayout
      loading={!!walletAddress && loading}
      getItemKey={transaction =>
        `${transaction.time}_${
          transaction.type === 'deposit'
            ? transaction.depositId
            : transaction.type === 'withdrawal'
            ? transaction.withdrawalId
            : transaction.quantity
        }`
      }
      // rowCustomizer={item => item.type === 'withdrawal' && item.katanaTxStatus === 'failed' ? { background: 'error' } : {}}
      firstColumnPaddingLeft="10px"
      onRowClick={isMobile ? item => onSelectRow(item) : undefined}
      columns={() => {
        return [
          {
            name: 'Date',
            render: transaction => formatDateTime(transaction.time),
          },
          {
            name: 'Type',
            stackWithPrevious: isMobile,
            fontFamily: 'standard',
            render: transaction => (
              <BalanceTransactionType transaction={transaction} />
            ),
          },
          {
            name: 'Quantity',
            align: isMobile ? 'right' : 'left',
            render: transaction => (
              <>
                <TextNumber value={formatUsd(transaction.quantity)} /> USDC
              </>
            ),
          },
          // { name: 'Bridge',
          //   fontFamily: 'standard',
          //   render: isMobile ? false : transaction => <BalanceTransactionBridge transaction={transaction} /> },
          {
            name: 'Chain',
            fontFamily: 'standard',
            render: isMobile
              ? false
              : transaction => (
                  <BalanceTransactionChain transaction={transaction} />
                ),
          },
          {
            name: 'Fee',
            render: isMobile
              ? false
              : transaction => (
                  <BalanceTransactionFee transaction={transaction} />
                ),
          },
          {
            name: 'Status',
            stackWithPrevious: isMobile,
            fontFamily: 'standard',
            align: 'right',
            // width: '1%', // Keeps size to minimum
            render: transaction => (
              <BalanceTransactionStatuses transaction={transaction} />
            ),
          },
          // {
          //   name: '',
          //   fontFamily: 'standard',
          //   width: EXPAND_COLUMN_WIDTH,
          //   render: isMobile ? <ExpandColumnIcon /> : false,
          // },
        ];
      }}
      errorText={
        !walletAddress ? (
          'Connect wallet to see your deposits and withdrawals'
        ) : loading ? undefined : !initialized ? (
          // Loading, prevents DOM shifts
          <>&nbsp;</>
        ) : historyEvents.length === 0 ? (
          'No balance history.'
        ) : undefined
      }
      items={historyEvents}
    />
  );
}
